export default __webpack_public_path__ + "static/media/1_fooddiary__august.2bdbf860.jpg";